const kbStage = {
    host: {            
        api :"https://9vuvwj1tc3.execute-api.ap-northeast-2.amazonaws.com/kb-stg"
    },
    playerEndpoint: "http://kb-cpm-stg-players.s3-website.ap-northeast-2.amazonaws.com/",
    deployDestination: "s3://kb-cpm-stg-shared-videos",
    profile: "mzc-media-kb-stg"
};

export default kbStage;
